<app-auth-container>
  <app-email-verify [verifier]="email" [email]="email" [password]="password" [referral]="referral" (verified)="submit()">
    <div class="submit-holder">
      <button type="submit" class="submit b-small ml-auto h6">{{ 'button.continue' | translate }}</button>
      <button type="button" routerLink="/entrar" queryParamsHandling="preserve" class="back btn-L btn-text">{{ 'button.back' | translate }}</button>
    </div>
  </app-email-verify>
</app-auth-container>
